<template>
    <v-layout row :key="$router.currentRoute.fullPath">
        <v-flex xs12 sm12>
            <v-card>
                <v-list two-line>
                    <template v-for="(student, index) in students">
                        <v-list-tile
                                :key="student.getFullName()"
                                avatar
                                ripple
                                @click="navigateToStudentDetail(student.id)"
                        >
                            <v-list-tile-avatar>
                                <v-icon>face</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ student.getFullName() }}</v-list-tile-title>
                                <v-list-tile-sub-title>
                                    <span class="text--secondary">Class: </span>
                                    <span class="text--primary">
                                        {{((classNames && classNames.get(student.id).map(c => c.name)) || []).join(', ')}}
                                    </span>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-btn icon ripple @click="navigateToHistory(student.id)">
                                    <v-icon color="grey ">trending_up</v-icon>
                                </v-btn>
                            </v-list-tile-action>

                        </v-list-tile>
                        <v-divider
                                v-if="index + 1 < students.length"
                                :key="index"
                        ></v-divider>
                    </template>
                </v-list>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import {Class} from "../state/models/Class";

    export default {
        data() {
            return {
                selected: [2],
                students: [],
                classNames: undefined,
            }
        },

        methods: {
            navigateToStudentDetail(studentId) {
                this.$router.push({
                    name: 'student',
                    params: {
                        id: studentId
                    }
                });
            },
            navigateToHistory(studentId) {
                this.$router.push({
                    name: 'test-history-chart',
                    query: {
                        studentId: studentId
                    }
                })
            },
        },

        mounted() {
            this.$store.dispatch('getStudents')
                .then((sList) =>{
                    if (!sList || !sList.length) {
                        return Promise.reject('Can\'t get students');
                    }
                    this.students = sList;
                    return Promise.resolve(sList);
                })
                .then((sList) => {
                    this.$store.dispatch('searchClasses', {studentIds: sList.map(s => s.id)})
                        .then((cList) => {
                            let result = new Map();

                            if (cList) {
                                cList.forEach(c => {
                                    if (!c.studentIds) {
                                        return;
                                    }
                                    for (let i = 0; i < c.studentIds.length; i++) {
                                        let existingEntry = result.get(c.studentIds[i]);
                                        if (!existingEntry) {
                                            result.set(c.studentIds[i], [c]);
                                        }
                                        else {
                                            existingEntry.push(c);
                                            result.set(c.studentIds[i], existingEntry);
                                        }
                                    }
                                })
                            }
                            this.classNames = result;
                        })
                });
        }
    }
</script>
